import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicBuildingFilled({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9 14.15a.5.5 0 00.5-.5V2.9a1 1 0 00-1-1h-6a1 1 0 00-1 1v10.75c0 .28.22.5.5.5h7zm5.25 0a.5.5 0 00.5-.5V8.72a1 1 0 00-.68-.95l-2.5-.83a1 1 0 00-1.32.95v5.76c0 .28.22.5.5.5h3.5zM4.05 4.2c0-.17.13-.3.3-.3h2.1c.17 0 .3.13.3.3v.9a.3.3 0 01-.3.3h-2.1a.3.3 0 01-.3-.3v-.9zm0 3.3c0-.17.13-.3.3-.3h2.1c.17 0 .3.13.3.3v.9a.3.3 0 01-.3.3h-2.1a.3.3 0 01-.3-.3v-.9zm0 3.3c0-.17.13-.3.3-.3h2.1c.17 0 .3.13.3.3v.9a.3.3 0 01-.3.3h-2.1a.3.3 0 01-.3-.3v-.9z"
      />
    </svg>
  );
}

SvgBasicBuildingFilled.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicBuildingFilled.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgBasicBuildingFilled svgRef={ref} {...props} />
));
export default ForwardRef;
